// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"fde3ad62","124":"62c583ad","214":"7e776846","353":"19331ae6","389":"35c8cc7b","435":"f81de098","453":"670e15c7","590":"9d0bec0d","603":"f05df86b","660":"b98dfdcb","910":"5febca33"}[chunkId] + ".chunk.js";
};